import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { StudentService } from 'src/app/services/Student/student.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { FinanceService } from 'src/app/services/Finance/finance.service';
import * as moment  from 'moment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-print-student-profile',
  templateUrl: './print-student-profile.component.html',
  styleUrls: ['./print-student-profile.component.css']
})
export class PrintStudentProfileComponent implements OnInit {
  StudentEnquiryModel = {
    Address: '',
    SectionName: '',
    LocationName: '',
    ClassName: '',
    Fax: '',
    ContactNo: '',
    ZipCode: '',
    PresentCity:'',
    PresentState:'',
    SpecialNeed: false,
    EmailID: '',
    HouseName: '',
    FirstName: '',
    
     StudentID:0,
     MiddleName: '',
     LastName: '',
     Gender: '0',
     SessionID: 0,
     DOB: '',
     BODRegNo: '',
     BloodGroupID: 0,
     NationalityID: 0,
     PermanentCountry: '',
     PrevSchool: '',
     ReligionID: 0,
     PrevClassID: 0,
     PermanentCity: '',
     MotherTongue: '',
     BranchID: 0,
     MotherTongueID: 0,
     PlaceOfBirth: '',
     CasteID: 0,
     PrintLogo:"",
     Religion: '',
     RelationShipID: 0,
     ClassID: 0,
     PresentCountryID: 0,
     BloodGroup: '',
     PassportNo: '',
     StreamID: 0,    
     Nationality: '',
     PresentAddress: '',
     PresentStateID: 0,
     PresentCityID: 0,
     Mobile: '',
     PresentZipCode: '',
     PermanentAddress: '',
     PermanentCountryID: 0,
     PermanentStateID: 0,
     PermanentCityID: 0,
     PermanentZipCode: '',
     FatherName: '',
     FatherOccupation: '',
     FatherQualificationID: 0,
     FatherPresentAddress: '',
     FatherPermanentAddress: '',
     FatherCompanyName: '',
     FatherCompanyAddress: '',
     FatherContactHome: '',
     FatherContactCell: '',
     FatherContactOffice: '',
     FatherOfficeEmailID: '',
     FatherPersonalMailID: '',     
     MotherName: '',
     MotherOccupation: '',
     MotherQualificationID: 0,
     MotherPresentAddress: '',
     MotherPermanentAddress: '',
     MotherCompanyName: '',
     MotherCompanyAddress: '',
     MotherContactWork: '',
     MotherContactHome: '',
     MotherContactCell: '',
     MotherContactOffice: '',
     MotherOfficeEmailID: '',
    
     DECLARATION: false,            
     IDCardTypeID: 0,
     IDCardNo: '',
     EnquiryNo: '',
     ParentID: 0,
     CategoryID: '0',
     SpecialCategoryID: '0',
     LocationID: '0',
     FatherPhotoPath:"",
     MotherPhotoPath:"",
     MotherPersonalMailID:"",
     FatherContactWork:"",
     FatherDesignation:"",
     MotherDesignation:"",
     FatherNationality:"",
     MotherNationality:"",
     HouseNo:"",
     WayNo:"",
     PermanentState:"",
     StreetName:"",
     Locality:"",
     POBox:"",
    StudentPOBox:'',
    AdmissionDate:'',
    AdmissionGradeID:0,
    RelationshipID:0,
    BranchName:"",
    BranchCode:"",
    Count:0,
    LatestGradeID:0,
    IsPresentAddress:false,
    PassedSchoolName: '',
    
    SectionID: 0,
    HouseID: 0,
   
    StudentNo: '',
    CountryID: 0,
    
   
    LastQualificationID: 0,
    PassedSchoolID: 0,
   
    Email: '',
    
    
    RouteID: 0,
    StartMonth: 0,
    
    VehicleID: 0,
    Phone: '',
    GaurdianName: '',
    StudentRelationship: '',
   
    PermanentMobile: '',
    PermanentPhone: '',
   
    AdmissionRemarks: '',
    RegistrationFee: 0,
    RegistrationDate: '',
    RegistrationNumber: '',
    PaymentMode: 0,
    BusStoppage: 0,
    StudentPhotoPath: '',
  
    IsWithdraw: false,
    StudentStatus: 0,
    WithDrawalReason: '',
    AdmissionSessionID: 0,
    
    ScholarshipID: '',
    
    GRNo: '',
    TotalAmount:0,
   

};
StudentView:any;
StudentID=0;
BrothersAndSistersList:any;
  constructor(private activatedRoute: ActivatedRoute,private financeService:FinanceService,private studentService:StudentService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { 
    this.activatedRoute.queryParams.subscribe(params => {
     
      this.StudentID =  params['StudentID'];
      this.StudentEnquiryModel.StudentID=this.StudentID ;
      this.GetStudentDetailsByStudentID ()
  });

  }
 GetStudentDetailsByStudentID  () {
   
   this. studentService.GetStudentProfileByStudentID(this.StudentEnquiryModel.StudentID).subscribe( (data)=> {
        this.StudentView = data.StudentViewList;
        this.StudentEnquiryModel = this.StudentView.StudentDetails;
        this.StudentEnquiryModel.AdmissionDate =moment(this.StudentView.StudentDetails.AdmissionDate).format("DD-MMM-YYYY")
        this.StudentEnquiryModel.SessionID = this.StudentView.StudentDetails.SessionID;
        this.BrothersAndSistersList = this.StudentView.StudentSeblingList;
        this.StudentEnquiryModel.SectionName=this.StudentView.StudentDetails.SectionName;
        this.StudentEnquiryModel.LocationName=this.StudentView.StudentDetails.LocationName;
        this.StudentEnquiryModel.ClassName=this.StudentView.StudentDetails.ClassName;
        this.StudentEnquiryModel.Fax=this.StudentView.StudentDetails.Fax;
        this.StudentEnquiryModel.ContactNo=this.StudentView.StudentDetails.ContactNo;
        this.StudentEnquiryModel.ZipCode=this.StudentView.StudentDetails.ZipCode;
        this.StudentEnquiryModel.SpecialNeed = this.StudentView.StudentDetails.SpecialNeed;
        this.StudentEnquiryModel.AdmissionSessionID = this.StudentView.StudentDetails.AdmissionSessionID;
        this.StudentEnquiryModel.ClassID = this.StudentView.StudentDetails.ClassID.toString().trim();
        this.StudentEnquiryModel.AdmissionGradeID = this.StudentView.StudentDetails.AdmissionGradeID.toString().trim();
        this.StudentEnquiryModel.LatestGradeID = this.StudentView.StudentDetails.LatestGradeID.toString().trim();
        this.StudentEnquiryModel.PrevClassID = this.StudentView.StudentDetails.PrevClassID.toString().trim();
        this.StudentEnquiryModel.SpecialCategoryID = this.StudentView.StudentDetails.SpecialCategoryID.toString().trim();
        this.StudentEnquiryModel.LocationID = this.StudentView.StudentDetails.LocationID.toString().trim();
        this.StudentEnquiryModel.CategoryID = this.StudentView.StudentDetails.CategoryID.toString().trim();
        this.StudentEnquiryModel.NationalityID = this.StudentView.StudentDetails.NationalityID;
        this.StudentEnquiryModel.ReligionID = this.StudentView.StudentDetails.ReligionID;
        this.StudentEnquiryModel.PrintLogo = this.StudentView.StudentDetails.PrintLogo;
        this.StudentEnquiryModel.SectionID = this.StudentView.StudentDetails.SectionID.toString().trim();
        this.StudentEnquiryModel.RelationshipID = this.StudentView.StudentDetails.RelationShipID;
        this.StudentEnquiryModel.StudentPhotoPath = this.StudentView.StudentDetails.StudentPhotoPath;
        this.StudentEnquiryModel.IDCardTypeID = this.StudentView.StudentDetails.IDCardTypeID.toString().trim();
        this.StudentEnquiryModel.IDCardNo = this.StudentView.StudentDetails.IDCardNo;
        this.StudentEnquiryModel.ScholarshipID = this.StudentView.StudentDetails.ScholarshipID;
        this.StudentEnquiryModel.HouseID = this.StudentView.StudentDetails.HouseID.toString().trim();
        this.StudentEnquiryModel.PresentCountryID =this.StudentView.StudentDetails.PresentCountryID;
       this.StudentEnquiryModel.PresentStateID = this.StudentView.StudentDetails.PresentStateID;
        this.StudentEnquiryModel.ParentID = this.StudentView.StudentDetails.ParentID;
        this.StudentEnquiryModel.Email = this.StudentView.StudentDetails.Email;
        this.StudentEnquiryModel.DOB = moment(this.StudentView.StudentDetails.DOB).format('DD-MMM-YYYY');
        this.StudentEnquiryModel.FirstName = this.StudentView.StudentDetails.FirstName;
        this.StudentEnquiryModel.StudentStatus = this.StudentView.StudentDetails.StudentStatus.toString().trim();
        this.StudentEnquiryModel.BranchName = this.StudentView.StudentDetails.BranchName;
        this.StudentEnquiryModel.BranchCode = this.StudentView.StudentDetails.BranchCode;
        this.StudentEnquiryModel.StudentNo = this.StudentView.StudentDetails.StudentNo;
        this.StudentEnquiryModel.GRNo = this.StudentView.StudentDetails.GRNo;
        this.StudentEnquiryModel.WithDrawalReason = this.StudentView.StudentDetails.WithDrawalReason;
        if (this.StudentEnquiryModel.StudentStatus == 5 || this.StudentEnquiryModel.StudentStatus == 9 || this.StudentEnquiryModel.StudentStatus == 10) {
            this.StudentEnquiryModel.IsWithdraw = true;
        }
       
        this.StudentEnquiryModel.PresentCityID = this.StudentView.StudentDetails.PresentCityID;
       
       window.print();
    });
};
 
  ngOnInit() {
  }

}
